<template>
  <p class="text-sm text-red-700 m-0">
    <slot />
  </p>
</template>
